import { Ai21StudioWhite } from "../../design-system/assets/logos";

/* Your agent, then the gateway, with traffic between them. Decorative and aria-hidden:
 * the status box below it carries the actual state. */
export function PipelineVisual({ used }: { used: boolean }) {
  return (
    <div aria-hidden className="flex items-center justify-center gap-3 py-4">
      <div
        className="flex size-10 items-center justify-center rounded-[6px] border"
        style={{ background: "#f9fafb", borderColor: "#d3d0d1" }}
      >
        <span
          className="text-[20px] font-bold"
          style={{ fontFamily: "var(--font-mono)", color: "#d3d0d1" }}
        >
          &gt;_
        </span>
      </div>

      <div className="flex items-center gap-1.5">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="size-[5px] rounded-full"
            style={{
              background: used ? "var(--val-green)" : "var(--val-crimson)",
              // Staggered so the row reads as movement towards the gateway.
              animation: used
                ? undefined
                : `twWait 1.4s ease-in-out ${i * 0.18}s infinite`,
            }}
          />
        ))}
      </div>

      <div
        className="flex size-10 items-center justify-center rounded-[5px]"
        style={{ background: "var(--onb-cta-bg)" }}
      >
        <Ai21StudioWhite className="h-[18px] w-auto text-white" />
      </div>
    </div>
  );
}
